<div class="welcome-banner-container">
  <h3 class="heading-3 mb-1">
    {{ greeting | translate }}{{ memberName ? ', ' + memberName : '' }}!
  </h3>
  <h2 class="heading-2 font-bold">
    {{ 'welcome_banner_sub_title' | translate }}
  </h2>
</div>
